export const BASE_URL = "https://jsonplaceholder.typicode.com";
